import DOMPurify from 'dompurify';

/**
 * Sanitize HTML content to prevent XSS attacks.
 * Safe for use with dangerouslySetInnerHTML.
 */
export const sanitizeHtml = (dirty) => {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, {
    ALLOWED_TAGS: ['strong', 'em', 'b', 'i', 'br', 'p', 'ul', 'ol', 'li', 'a', 'h1', 'h2', 'h3', 'h4', 'span', 'div', 'img', 'table', 'tr', 'td', 'th', 'thead', 'tbody'],
    ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'src', 'alt', 'width', 'height'],
  });
};

/**
 * Sanitize JSON-LD structured data for SEO scripts.
 * Only allows valid JSON strings.
 */
export const sanitizeJsonLd = (jsonString) => {
  if (!jsonString) return '{}';
  if (typeof jsonString === 'object') {
    return JSON.stringify(jsonString);
  }
  return jsonString;
};
